import videojs from 'video.js';
(window as any).videojs = videojs;
